//===== ADMIN =====//

const StartNoisemeter = async (gameData) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "noisemeter/start", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(gameData) // gameData ya viene con la estructura correcta del DTO
        })
        
        if (!response.ok) {
            // Intentamos leer el JSON de error del backend
            let errorMessage = 'No ha sido posible iniciar el Ladrómetro.';
            try {
                const errorData = await response.json();
                if (errorData && errorData.message) errorMessage = errorData.message;
            } catch (e) {
                // Si no es JSON, usamos el statusText
                errorMessage += ` (${response.statusText})`;
            }
            return { success: false, message: errorMessage }
        }
        
        const data = await response.json();
        return { success: true, data: data }

    } catch (error) {
        return { success: false, message: 'Error de conexión al iniciar el Ladrómetro.' }
    }
}

const StopNoisemeter = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "noisemeter/stop", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al detener el Ladrómetro.' }
        }

        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Error de conexión al detener.' }
    }
}

const ResetNoisemeter = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "noisemeter/reset", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al reiniciar.' }
        }

        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Error de conexión al reiniciar.' }
    }
}

const GetNoisemeterStats = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "noisemeter/stats", {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            return { success: false, message: 'Error obteniendo estadísticas.' }
        }

        const data = await response.json();
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de conexión (stats).' }
    }
}

// Nueva función para obtener las zonas dinámicas
// const GetActiveZones = async () => {
//     try {
//         // Usamos el endpoint existente de balanceo para saber qué zonas hay
//         // O si creas uno específico en AdminController como GetActiveZonesConfig
//         const response = await fetch(process.env.REACT_APP_API_URL + "admin/GetWomensBalance", { 
//             method: 'GET',
//             headers: { 'Content-Type': 'application/json' }
//         })

//         if (!response.ok) {
//             return { success: false, message: 'No se pudieron cargar las zonas.' }
//         }

//         const data = await response.json();
//         return { success: true, data: data } // Retorna objeto con claves de zonas
//     } catch (error) {
//         return { success: false, message: 'Error al consultar zonas activas.' }
//     }
// }

const GetActiveZones = async () => {
    try {
        // CAMBIO: Apuntamos al nuevo endpoint genérico
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/GetActiveZones", { 
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            return { success: false, message: 'No se pudieron cargar las zonas.' }
        }

        const data = await response.json();
        // data ya debería ser un array de strings: ["azul", "oro"] o ["tecate", "mobil", ...]
        return { success: true, data: data } 
    } catch (error) {
        return { success: false, message: 'Error al consultar zonas activas.' }
    }
}

//===== ADMIN =====//





//===== FAN =====//

const ReportNoiseLevel = async (reportData) => {
    try {
        // reportData: { matchId, zone, volume }
        const response = await fetch(process.env.REACT_APP_API_URL + "noisemeter/report", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reportData)
        })
        
        // No esperamos respuesta estricta para no bloquear el hilo de audio,
        // pero validamos si fue exitoso el envío.
        if (!response.ok) {
            return { success: false, message: response.message }
        }
        
        return { success: true, data: null }

    } catch (error) {
        return { success: false, message: error }
    }
}

//===== FAN =====//





//===== SCREEN =====//

const GetNoisemeterState = async () => {
    try {
        // Reutilizamos el endpoint de stats que creamos para el Admin, 
        // ya que tiene toda la info necesaria (score, porcentaje, ganadores).
        const response = await fetch(process.env.REACT_APP_API_URL + "noisemeter/stats", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            return { success: false, message: 'Error de conexión.' }
        }
        
        const data = await response.json()
        return { success: true, data: data }

    } catch (error) {
        return { success: false, message: 'Error de red.' }
    }
}

//===== SCREEN =====//

export { StartNoisemeter, StopNoisemeter, ResetNoisemeter, GetNoisemeterStats, GetActiveZones, ReportNoiseLevel, GetNoisemeterState };